import { makeStyles, mergeClasses, tokens } from "@fluentui/react-components";
import React from "react";
import { PassengersData } from "../../models/flights/IFlightsCommon";
import {
  formatDisplayValue,
  formatHeaderDisplayValue,
} from "../../utils/common/FormatHelper";
import { PersonWalkingLuggageIcon } from "../common/icons/person-walking-luggage/personWalkingLuggageIcon";
import CardHeader from "./CardHeader";
import { useCardStyles } from "./shared.styles";

interface PassengersCardProps {
  data: PassengersData;
  className?: string;
}

const PassengersCard: React.FC<PassengersCardProps> = ({ data, className }) => {
  const shared = useCardStyles();
  const local = useLocalStyles();

  return (
    <article className={mergeClasses(shared.container, className)}>
      <CardHeader
        icon={<PersonWalkingLuggageIcon />}
        title="Passengers"
        primaryValue={formatHeaderDisplayValue(data.totalPassengers)}
      />

      <section className={shared.content}>
        <dl className={local.columnsWrapper}>
          <div className={shared.column}>
            <div className={shared.row}>
              <dt className={mergeClasses(shared.label, local.label)}>
                Capacity
              </dt>
              <dd className={mergeClasses(shared.value, local.value)}>
                {formatDisplayValue(data.capacity)}
              </dd>
            </div>
            <div className={shared.row}>
              <dt className={mergeClasses(shared.label, local.label)}>
                Booked
              </dt>
              <dd className={mergeClasses(shared.value, local.value)}>
                {formatDisplayValue(data.booked)}
              </dd>
            </div>
            <div className={shared.row}>
              <dt className={mergeClasses(shared.label, local.label)}>
                Accepted
              </dt>
              <dd className={mergeClasses(shared.value, local.value)}>
                {formatDisplayValue(data.accepted)}
              </dd>
            </div>
          </div>

          <div className={shared.column}>
            <div className={shared.row}>
              <dt className={mergeClasses(shared.label, local.label)}>
                Boarded
              </dt>
              <dd className={mergeClasses(shared.value, local.value)}>
                {formatDisplayValue(data.boarded)}
              </dd>
            </div>
            <div className={shared.row}>
              <dt className={mergeClasses(shared.label, local.label)}>
                Computed
              </dt>
              <dd className={mergeClasses(shared.value, local.value)}>
                {formatDisplayValue(data.computed)}
              </dd>
            </div>
            <div className={shared.row}>
              <dt className={mergeClasses(shared.label, local.label)}>
                Transfer
              </dt>
              <dd className={mergeClasses(shared.value, local.value)}>
                {formatDisplayValue(data.transfer)}
              </dd>
            </div>
          </div>
        </dl>
      </section>
    </article>
  );
};

export default PassengersCard;

const useLocalStyles = makeStyles({
  noDataContainer: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    height: "100%",
    fontSize: tokens.fontSizeBase400,
    fontWeight: tokens.fontWeightSemibold,
    color: tokens.colorNeutralForeground3,
    margin: 0,
  },
  columnsWrapper: {
    display: "flex",
    flexDirection: "row",
    gap: "32px",
    margin: 0,
  },
  label: {
    width: "65px",
  },
  value: {
    width: "35px",
  },
});
